// src/channelCasingConverter/channelCasingConverter.ts
var e = {}, t = {
	email: {
		pascal: "Email",
		truncate: "email"
	},
	contact_form: {
		pascal: "ContactForm",
		truncate: "contactform"
	},
	widget_chat: {
		pascal: "WidgetChat",
		truncate: "widgetchat"
	},
	messenger: {
		pascal: "Messenger",
		truncate: "messenger"
	},
	facebook_messenger: {
		pascal: "FacebookMessenger",
		truncate: "facebookmessenger"
	},
	whats_app: {
		pascal: "WhatsApp",
		truncate: "whatsapp"
	},
	pstn_phone: {
		pascal: "PstnPhone",
		truncate: "pstnphone"
	},
	callback: {
		pascal: "Callback",
		truncate: "callback"
	},
	voicemail: {
		pascal: "Voicemail",
		truncate: "voicemail"
	},
	sms: {
		pascal: "Sms",
		truncate: "sms"
	},
	twitter: {
		pascal: "Twitter",
		truncate: "twitter"
	},
	adachat: {
		pascal: "AdaChat",
		truncate: "adachat"
	},
	digitalgeniuschat: {
		pascal: "DigitalGeniusChat",
		truncate: "digitalgeniuschat"
	},
	kindlychat: {
		pascal: "KindlyChat",
		truncate: "kindlychat"
	},
	genericapimessaging: {
		pascal: "GenericApiMessaging",
		truncate: "genericapimessaging"
	},
	trustpilotreviews: {
		pascal: "TrustpilotReviews",
		truncate: "trustpilotreviews"
	},
	yotporeviews: {
		pascal: "YotpoReviews",
		truncate: "yotporeviews"
	}
};
function n(n, r) {
	let i = `${n}:${r}`;
	if (e[i]) return e[i];
	let a = t[n];
	if (a) return r === "snake" ? n : a[r];
	let o = Object.keys(t).find((e) => [t[e].pascal, t[e].truncate].includes(n)), s = r === "snake" ? o : t[o ?? ""]?.[r] || n;
	return e[i] = s, s;
}
// src/pagination/paginatedQuery/paginatedQuery.ts
var r = 0, i = 25;
function a(e, t, n = {}) {
	if (typeof e == "string") return e;
	let { limit: r, offset: i, sort: a, searchTerm: l, ...u } = e, d = t(u);
	return {
		...d,
		params: {
			...d.params || {},
			...o({
				limit: r,
				offset: i
			}, n),
			...s({ searchTerm: l }, n),
			...c({ sort: a }, { searchTerm: l }, n)
		}
	};
}
function o({ limit: e, offset: t }, { pagination: n = {} }) {
	switch (n.paramNaming) {
		case "pageSizePage": return {
			...e === void 0 ? { pageSize: n.defaultLimit ?? 25 } : { pageSize: e },
			...t === void 0 ? {} : { page: t / (e ?? n.defaultLimit ?? 25) }
		};
		case "pageSizePageNumber": return {
			...e === void 0 ? { page_size: 25 } : { page_size: e },
			...t === void 0 ? {} : { page_number: t / (e ?? n.defaultLimit ?? 25) }
		};
		case "limitPage": return {
			...e === void 0 ? { limit: n.defaultLimit ?? 25 } : { limit: e },
			...t === void 0 ? {} : { page: t / (e ?? n.defaultLimit ?? 25) }
		};
		case "limitCount": return {
			...e === void 0 ? { limit: n.defaultLimit ?? 25 } : { limit: e },
			...t === void 0 ? {} : { count: t }
		};
		default: return {
			...e === void 0 ? { limit: n.defaultLimit ?? 25 } : { limit: e },
			...t === void 0 ? {} : { offset: t }
		};
	}
}
function s({ searchTerm: e }, { search: t = {} }) {
	let n = e ?? t.default;
	return n === void 0 ? {} : { [t.paramName ?? "search"]: n };
}
function c({ sort: e }, { searchTerm: t }, { sort: n = {}, search: r = {} }) {
	let i = e ?? n.default, a;
	return m(i) ? a = i.map(({ key: e, direction: t }) => `${e}:${t || "asc"}`).join(",") : i && (a = `${i.key}:${i.direction || "asc"}`), a !== void 0 && (r.supportsSortedSearch && t || !t) ? { [n.paramName ?? "sort_by"]: a } : {};
}
function l(e) {
	if (p(e)) {
		let { pageSize: t, page: n } = e;
		return {
			...t === void 0 ? {} : { limit: t },
			...t !== void 0 && n !== void 0 ? { offset: t * n } : {}
		};
	}
	if (f(e)) {
		let { page_size: t, page_number: n } = e;
		return {
			...t === void 0 ? {} : { limit: t },
			...t !== void 0 && n !== void 0 ? { offset: t * n } : {}
		};
	}
	if (d(e)) {
		let { limit: t, page: n } = e;
		return {
			...t === void 0 ? {} : { limit: t },
			...n !== void 0 && t !== void 0 ? { offset: n * t } : {}
		};
	}
	if (u(e)) {
		let { limit: t, count: n } = e;
		return {
			...t === void 0 ? {} : { limit: t },
			...n === void 0 ? {} : { offset: n }
		};
	}
	return {
		limit: e.limit,
		offset: e.offset
	};
}
function u(e) {
	return e.limit !== void 0 && e.count !== void 0;
}
function d(e) {
	return e.limit !== void 0 && e.page !== void 0;
}
function f(e) {
	return e.page_size !== void 0 && e.page_number !== void 0;
}
function p(e) {
	return e.pageSize !== void 0 && e.page !== void 0;
}
function m(e) {
	return e ? Array.isArray(e) : !1;
}
// src/streamCount.ts
var h = 0, g = () => h, _ = () => {
	h += 1;
}, v = async ({ url: e, body: t, headers: n = {}, signal: r, isCancelled: i, onStart: a, onChunk: o, onCancelled: s, onDone: c, onError: l }) => {
	try {
		let u = await fetch(e, {
			method: "POST",
			headers: {
				...n,
				"Content-Type": "application/json"
			},
			body: JSON.stringify(t),
			signal: r
		});
		if (!u.ok) {
			l(u);
			return;
		}
		let d = u.body?.getReader();
		if (!d) {
			l(u);
			return;
		}
		a?.();
		let f = new TextDecoder();
		for (;;) {
			if (i?.()) {
				s?.();
				return;
			}
			let { done: e, value: t } = await d.read();
			if (e) {
				c(u);
				return;
			}
			t && o(f.decode(t, { stream: !0 }));
		}
	} catch (e) {
		e.name !== "AbortError" && l();
	}
}, y = async (e, t, n) => {
	let { url: r, body: i, headers: a } = t;
	_();
	let o = g();
	await v({
		url: r,
		body: i,
		headers: a,
		isCancelled: () => o !== g(),
		onStart: () => {
			e((e) => {
				e.meta.isLoading = !1, e.meta.isStreaming = !0;
			});
		},
		onChunk: (t) => {
			e((e) => {
				n ? n(e, t) : e.text += t;
			});
		},
		onCancelled: () => {
			e((e) => {
				e.meta.isLoading = !0, e.meta.isStreaming = !1, e.text = "";
			});
		},
		onDone: (t) => {
			e((e) => {
				e.meta.isStreaming = !1, e.meta.isSuccess = !0, e.feedback_id = t.headers.get("dixa-context-id") ?? "";
			});
		},
		onError: (t) => {
			e((e) => {
				e.meta.isLoading = !1, e.meta.isError = !0, t && (e.feedback_id = t.headers.get("dixa-context-id") ?? "");
			});
		}
	});
};
export { n as convertChannelCasing, i as defaultPaginatedLimit, r as defaultPaginatedOffset, l as getPaginatedApiParams, g as getStreamCount, _ as incrementStreamCount, m as isSortArgArray, a as paginatedQuery, v as streamReader, y as streamUpdates };

//# sourceMappingURL=index.js.map